import { render, staticRenderFns } from "./ReadLetter.vue?vue&type=template&id=744fb546&scoped=true&"
import script from "./ReadLetter.vue?vue&type=script&lang=ts&"
export * from "./ReadLetter.vue?vue&type=script&lang=ts&"
import style0 from "./ReadLetter.vue?vue&type=style&index=0&id=744fb546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744fb546",
  null
  
)

export default component.exports